import React from "react";
// React Bootstrap
import { Container } from "react-bootstrap";
const VistaDescripcion = ({ descripcion }) => {
  return (
    <Container>
      <p>{descripcion || <small>No especificado</small>}</p>
    </Container>
  );
};

export default VistaDescripcion;
